/** Angular `getTextExcerpt` — short description for list cells (130 chars, same as Product list). */
export function getModelDescriptionExcerpt(description: string | null | undefined, maxLength = 130): string {
  const text = String(description ?? '').trim()
  if (!text) return '—'
  if (text.length <= maxLength) return text
  return `${text.slice(0, maxLength).trim()}...`
}

export function isBaseModel(modelId: number | string | null | undefined): boolean {
  return Number(modelId) === 1
}

export function isModelActive(isActive: unknown): boolean {
  return Number(isActive) === 1
}
